function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#2d9cdb"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.046 23.268H4.955a.489.489 0 00-.466.509.5.5 0 00.466.521h7.091a.5.5 0 00.466-.521.493.493 0 00-.466-.509"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.22 22.784H4.78a.8.8 0 01-.814-.774v-2.13a7.861 7.861 0 01-2.435-2.539h-.005a7.331 7.331 0 011.314-9.11A8.165 8.165 0 018.5 6a8.161 8.161 0 015.659 2.231 7.369 7.369 0 012.341 5.376 7.276 7.276 0 01-1.032 3.734h.007a7.94 7.94 0 01-2.441 2.539v2.13a.8.8 0 01-.814.774zm-9.286-6.195h0a6.333 6.333 0 002.2 2.181.772.772 0 01.46.695v1.783h5.819v-1.783a.771.771 0 01.389-.655 6.209 6.209 0 002.258-2.22h.006a5.858 5.858 0 00-1.056-7.266A6.528 6.528 0 008.5 7.552 6.5 6.5 0 004 9.324a5.886 5.886 0 00-1.879 4.288 5.8 5.8 0 00.82 2.977z",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.764 24.977H6.236a.518.518 0 00-.515.515.512.512 0 00.515.509h4.528a.512.512 0 00.515-.509.518.518 0 00-.515-.515"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  "data-name": "p3",
  d: "M2.136 5.767a.8.8 0 101.133-1.132l-1.4-1.385a.789.789 0 00-1.133 0 .783.783 0 000 1.113z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "p2",
  d: "M7.687 2.779a.808.808 0 00.8.8.8.8 0 00.794-.8V.804a.8.8 0 00-.794-.8.808.808 0 00-.8.8z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "p1",
  d: "M13.74 4.548a.807.807 0 000 1.133.825.825 0 001.133 0l1.398-1.395a.807.807 0 000-1.133.8.8 0 00-1.123 0z"
})));

var SvgIconDenkyuu = function SvgIconDenkyuu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 26
  }, props), _ref);
};

export default SvgIconDenkyuu;